<template>
    <div class="o-vacancies-listing__header">
        <div class="o-vacancies-listing__subtitle">
            {{ $t("vacancies.start_searching_title") }}
        </div>
        <h2 class="o-vacancies-listing__title">
            {{ $t("vacancies.start_searching_message") }}
        </h2>
    </div>
</template>
<script>
    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'VacanciesList',
        mixins: [vacanciesMixin],
        data() {
            return {
            }
        }
    }
</script>